import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';

type PluginProps = {
  operationsSelected: Operation[];
};

const DashboardPlugin: React.FC<PluginProps> = React.lazy(() => importFromS3('dashboard'));

export const DashboardPluginContainer = ({ operationsSelected }: PluginProps) => (
  <DashboardPlugin operationsSelected={operationsSelected} />
);
